import React from "react";
import "./LandingWelbyAnimation.css";

import body from "../../assets/leaf/Background.png";
import leftArm from "../../assets/leaf/left_arm.png";
import rightArm from "../../assets/leaf/right_arm.png";
import leftLeg from "../../assets/leaf/left_leg.png";
import rightLeg from "../../assets/leaf/right_leg.png";
import leftBrow from "../../assets/leaf/left_brow.png";
import rightBrow from "../../assets/leaf/right_brow.png";
import leftEye from "../../assets/leaf/left_eye.png";
import rightEye from "../../assets/leaf/right_eye.png";
import leftBlush from "../../assets/leaf/left_blush.png";
import rightBlush from "../../assets/leaf/right_blush.png";
import mouth from "../../assets/leaf/mouth.png";

export default function LandingWelbyAnimation({ animation = "idle" }) {
  return (
    <div className={`welby-animation ${animation}`}>
      <div className="head">
        <img src={body} className="part body" alt="body" />
        <img src={leftBrow} className="part left-brow" alt="left brow" />
        <img src={rightBrow} className="part right-brow" alt="right brow" />
        <img src={leftEye} className="part left-eye" alt="left eye" />
        <img src={rightEye} className="part right-eye" alt="right eye" />
        <img src={leftBlush} className="part left-blush" alt="left blush" />
        <img src={rightBlush} className="part right-blush" alt="right blush" />
        <img src={mouth} className="part mouth" alt="mouth" />
      </div>

      <img src={leftArm} className="part left-arm" alt="left arm" />
      <img src={rightArm} className="part right-arm" alt="right arm" />
      <img src={leftLeg} className="part left-leg" alt="left leg" />
      <img src={rightLeg} className="part right-leg" alt="right leg" />
    </div>
  );
}